import { useQuery } from '@tanstack/react-query';

import { BASE_QUERY_KEY } from '../../utils/constants';
import useUpdateListQuery from '../../utils/use-update-list-query';

import useAccessRequestsApi from './use-access-requests-api';

import { QUERY_KEY as LIST_ACCESS_REQUESTS_QUERY_KEY } from './use-list-access-requests';

export const QUERY_KEY = 'getMultipleAccessRequests';

export default function useGetMultipleAccessRequests(ids: string[], refetch?: number) {
  const api = useAccessRequestsApi();
  const updateListQuery = useUpdateListQuery([BASE_QUERY_KEY, LIST_ACCESS_REQUESTS_QUERY_KEY]);

  const fetch = async () => {
    const requests = await Promise.all(ids.map((id) => api.getAccessRequest({ id })));
    for (const request of requests) {
      updateListQuery(request);
    }
    return requests;
  };

  const { data: requests, ...restProps } = useQuery([BASE_QUERY_KEY, QUERY_KEY, ids.join(',')], fetch, {
    initialData: [],
    refetchInterval: refetch,
  });

  return { requests, ...restProps };
}
